<template>
    <woot-dropdown-item class="reset-conversations--toggle">
        <div class="info-wrap">
            <fluent-icon
              v-tooltip.right-start="$t('SIDEBAR_ITEMS.RESET_CONVERSATIONS')"
              icon="info"
              size="14"
              class="info-icon"
            />

            <span class="reset-conversations--text">
              {{ $t('SIDEBAR_ITEMS.RESET_CONVERSATIONS') }}
            </span>
        </div>

        <woot-switch
            size="small"
            class="reset-conversations--switch"
            :value="valueResetConversation"
            @input="handleResetConversation"
        />
    </woot-dropdown-item>
</template>

<script>
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export default {
    data() {
        return {
            valueResetConversation: !!LocalStorage.get(LOCAL_STORAGE_KEYS.RESET_CONVERSATIONS),
        }
    },
    watch: {
        valueResetConversation(value) {
            LocalStorage.set(LOCAL_STORAGE_KEYS.RESET_CONVERSATIONS, value);
            // Atualizar a pagina para o javascript pegar a config
            window.location.reload();
        },
    },
    methods: {
        handleResetConversation(value) {
            this.valueResetConversation = value;
        }
    }
}
</script>

<style lang="scss">
.reset-conversations--toggle {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--space-smaller);
  margin: 0;

  .info-wrap {
    display: flex;
    align-items: center;
  }

  .info-icon {
    margin-top: -1px;
  }

  .reset-conversations--switch {
    margin: -1px var(--space-micro) 0;
  }

  .reset-conversations--text {
    margin: 0 var(--space-smaller);
    font-size: var(--font-size-mini);
    font-weight: var(--font-weight-medium);
    color: var(--s-700);
  }
}
</style>